// ABOUTME: Error placeholder shown in the detail body when entity data fails to load.
// ABOUTME: Stub component — will be enhanced with retry logic when API integration is added.
import {TextSmallRegular} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'

export const EntityContentError: React.FC = () => {
  const {t} = useTranslation()

  return (
    <div className="flex items-center justify-center h-full p-8">
      <TextSmallRegular className="text-foreground_faded">
        {t('countryConfigurations.entity.body.error')}
      </TextSmallRegular>
    </div>
  )
}
